import "./styles.scss";
import React from "react";

const mainClass = "side-header";

const SideHeader = ({ header, text }) => {
  return (
    <div className={mainClass}>
      <div className="container">
        <h2>{header}</h2>
        <span
          dangerouslySetInnerHTML={{ __html: text.split("|").join("<br/>") }}
        />
      </div>
    </div>
  );
};

export default SideHeader;
